/**
 * This files dynamically compiles the module routes for the client and
 * redirects any route that doesn't match to a 'NotFound'/404 page
 *
 * Below we import all module routes and assign them top-level pathnames as the
 * kebab-case version of their moduleName. For example in moduleRoutes.js.jsx:
 * export { default as userWorkouts } ... would become a top-level Route with the
 * path="/user-workouts" and so on.
 */

// import primary libraries
import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import YTRoute from './global/components/routing/YTRoute.js.jsx';

// import third-party libraries
import _ from 'lodash';

export { default as static } from './modules/static/StaticRouter.js.jsx';

// import custom components
import Forbidden from './modules/static/views/Forbidden.js.jsx';
import Landing from './modules/static/views/Landing.js.jsx';
import NotFound from './modules/static/views/NotFound.js.jsx';
import StaticRouter from './modules/static/StaticRouter.js.jsx';
import * as moduleRoutes from './modules/moduleRoutes.js';
import RedirectToRoleBasedRoot from './global/components/routing/RedirectToRoleBasedRoot.js.jsx';

//testing
import LandingPageLogin from './modules/user/views/LandingPageLogin.js.jsx';
import ContactUs from './modules/static/views/ContactUs.js.jsx';
import ReleaseNotes from './modules/static/views/ReleaseNotes.js.jsx';

const routes =
  <Switch>
    <YTRoute login={true} exact path="/" component={RedirectToRoleBasedRoot} />
    
    {/* begin static routes */}
    <YTRoute exact path="/partner/:name" component={LandingPageLogin} />
    <YTRoute exact path="/portal/:name" component={LandingPageLogin} />
    <YTRoute exact path="/portal/partner/:name" component={LandingPageLogin} />

    <YTRoute login={true} exact path="/contact-us" component={ContactUs} />
    <YTRoute login={true} exact path="/release-notes" component={ReleaseNotes} />

    {/* end static routes */}

    <Route path="/unauthorized" component={Forbidden} />
    { Object.keys(moduleRoutes).map((moduleName, i) => 
      <Route
        component={moduleRoutes[moduleName]}
        key={Math.floor(Math.random()*100000)}
        path={`/${_.kebabCase(moduleName)}`}
      />
    )}
    <Route component={NotFound} />
  </Switch>
;

export default routes;



// WEBPACK FOOTER //
// routes.js.jsx